import request from '@/utils/request'


// 查询结算单据列表
export function listReceipt(query) {
  return request({
    url: '/account/receipt/list',
    method: 'get',
    params: query
  })
}

// 查询结算单据分页
export function pageReceipt(query) {
  return request({
    url: '/account/receipt/page',
    method: 'get',
    params: query
  })
}

// 查询结算单据详细
export function getReceipt(data) {
  return request({
    url: '/account/receipt/detail',
    method: 'get',
    params: data
  })
}

// 新增结算单据
export function addReceipt(data) {
  return request({
    url: '/account/receipt/add',
    method: 'post',
    data: data
  })
}

// 修改结算单据
export function updateReceipt(data) {
  return request({
    url: '/account/receipt/edit',
    method: 'post',
    data: data
  })
}

// 删除结算单据
export function delReceipt(data) {
  return request({
    url: '/account/receipt/delete',
    method: 'post',
    data: data
  })
}
